import React from 'react';
import { NavLink } from 'react-router-dom';
import { Inbox, Package, Image as ImageIcon } from 'lucide-react';

const AdminTabs = () => {
  const base = 'inline-flex items-center gap-2 px-4 h-10 rounded-full text-sm font-semibold transition-colors';
  const inactive = 'text-stone-600 hover:text-pink-brand hover:bg-blush/60';
  const active = 'bg-pink-brand text-white shadow-pink-glow';

  return (
    <div className="flex items-center gap-2 bg-white border border-pink-100 rounded-full p-1 shadow-soft w-fit flex-wrap">
      <NavLink to="/admin" end className={({ isActive }) => `${base} ${isActive ? active : inactive}`} data-testid="admin-tab-enquiries">
        <Inbox className="w-4 h-4" /> Enquiries
      </NavLink>
      <NavLink to="/admin/orders" className={({ isActive }) => `${base} ${isActive ? active : inactive}`} data-testid="admin-tab-orders">
        <Package className="w-4 h-4" /> Orders
      </NavLink>
      <NavLink to="/admin/product-images" className={({ isActive }) => `${base} ${isActive ? active : inactive}`} data-testid="admin-tab-images">
        <ImageIcon className="w-4 h-4" /> Photos
      </NavLink>
    </div>
  );
};

export default AdminTabs;
